import { useMarginEnabled } from 'queries/marginEnabled';

export function useMarginAccountEnabled(): boolean {
    const { data } = useMarginEnabled();
    return data?.enabled === true;
}
